import { isValidTiptapBody } from "@circle-react/components/QuickPostV3/data/tiptapBody";
import type { TiptapBody } from "@circle-react/components/QuickPostV3/data/types";
import * as yup from "yup";

import { canonicalUrlSchema } from "@/react/helpers/postCanonicalUrl";

export { isValidTiptapBody };

export const isValidBody = (body: unknown) => Boolean(body);

export const isValidName = (name: unknown) => Boolean(name);
const commonValidationSchema = yup.object().shape({
  space_id: yup.number().required(),
  meta_tag_attributes: yup.object().shape({
    canonical_url: canonicalUrlSchema,
  }),
});

export const trixValidationSchema = yup
  .object()
  .shape(
    {
      name: yup.string().when("body", {
        is: (body: unknown) => !isValidBody(body),
        then: yup.string().required(),
        otherwise: yup.string().nullable(),
      }),
      body: yup.string().when("name", {
        is: (name: unknown) => !isValidName(name),
        then: yup.string().required(),
        otherwise: yup.string().nullable(),
      }),
    },
    [["name", "body"]],
  )
  .concat(commonValidationSchema);

export const tiptapValidationSchema = yup
  .object()
  .shape(
    {
      name: yup.string().when("tiptap_body", {
        is: (tiptapBody: TiptapBody | undefined) =>
          !isValidTiptapBody(tiptapBody),
        then: yup.string().required(),
        otherwise: yup.string().nullable(),
      }),
      tiptap_body: yup.object().when("name", {
        is: (name: unknown) => !isValidName(name),
        then: yup.object().test({
          test: (value: TiptapBody | undefined) => isValidTiptapBody(value),
        }),
        otherwise: yup.object().nullable(),
      }),
    },
    [["name", "tiptap_body"]],
  )
  .concat(commonValidationSchema);
